module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Db-Ee.af471ddb.png";